import { forwardRef, MenuGroup, StyleProps } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

export interface DropdownGroupProps extends StyleProps, PropsWithChildren {
	title: string;
}

export const DropdownGroup = forwardRef<DropdownGroupProps, 'div'>(({ children, ...rest }, ref) => {
	return (
		<MenuGroup ref={ref} color="text.softer" fontWeight="semibold" fontSize="sm" mx={1} my={2} {...rest}>
			{children}
		</MenuGroup>
	);
});

DropdownGroup.displayName = 'DropdownGroup';
